<ng-container *ngIf="logged">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="(isHandset$ | async) === false">
      <mat-toolbar style="width: 100%; height: 120px; margin-top: 20px;">
        <img [src]="logoPath" style="width: 100%;">
      </mat-toolbar>
      <mat-nav-list>
        <a mat-list-item [routerLink]="['/dashboard']" routerLinkActive="nav-item-active" [routerLinkActiveOptions]="{ exact: true }">
          <mat-icon matListItemIcon>dashboard</mat-icon>
          Dashboard
        </a>
        <a mat-list-item [routerLink]="['/contracts']" routerLinkActive="nav-item-active">
          <mat-icon matListItemIcon>description</mat-icon>
          Contracts
        </a>
        <a mat-list-item [routerLink]="['/transfer-history']" routerLinkActive="nav-item-active">
          <mat-icon matListItemIcon>history</mat-icon>
          Transfer history
        </a>

        <div class="nav-group-label">Consume</div>
        <a mat-list-item [routerLink]="['/catalog-browser']" routerLinkActive="nav-item-active">
          <mat-icon matListItemIcon>menu_book</mat-icon>
          Catalog
        </a>

        <div class="nav-group-label">Provide</div>
        <a mat-list-item [routerLink]="['/data-offers']" routerLinkActive="nav-item-active">
          <mat-icon matListItemIcon>upload</mat-icon>
          New data offer
        </a>
        <a mat-list-item [routerLink]="['/policies']" routerLinkActive="nav-item-active">
          <mat-icon matListItemIcon>policy</mat-icon>
          Policies
        </a>
        <a mat-list-item [routerLink]="['/my-assets']" routerLinkActive="nav-item-active">
          <mat-icon matListItemIcon>inbox</mat-icon>
          Assets
        </a>
      </mat-nav-list>

      <div class="sidenav-spacer"></div>

      <div class="user-menu-container" [matMenuTriggerFor]="userMenu">
        <div class="user-menu-trigger">
          <mat-icon>account_circle</mat-icon>
          <span class="user-menu-name">{{ username || 'User' }}</span>
          <mat-icon class="user-menu-chevron">chevron_right</mat-icon>
        </div>
      </div>

      <mat-menu #userMenu="matMenu" xPosition="before" yPosition="above" [overlapTrigger]="false">
        <div class="logout-btn" mat-menu-item [routerLink]="['/logout']">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </div>
      </mat-menu>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar class="main-toolbar">
        <div class="icon-btn">
          <button
          class="icon-button"
            type="button"
            aria-label="Toggle sidenav"
            mat-flat-button
            color="accent"
            (click)="drawer.toggle()"
            *ngIf="isHandset$ | async">
            <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
        </div>
        <div class="title">
          <mat-icon>{{ getSectionIcon() }}</mat-icon>
          <span>{{titleService.getTitle()}}</span>
        </div>
      </mat-toolbar>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>